




































import { computed, defineComponent, ref, watch, watchEffect } from '@vue/composition-api';
import { FIELDS_LIST_ADDITIONAL_AMOUNT_TO_SHOW_ON_VIEW_MORE, FIELDS_LIST_DEFAULT_NUMBER_TO_RENDER } from '@/constants';
import { useGroups } from '@/store/modules/group';
import { useAllResources } from '@/store/modules/resources';
import { FieldRow } from '@/store/types';
import FieldListRow from './FieldListRow.vue';

export default defineComponent({
	components: {
		FieldListRow,
	},
	setup(_, { root }) {
		const {
			isLoaded: areResourcesLoaded,
			isLoading: areResourcesLoading,
			fields,
			hasError: hasResourcesError,
		} = useAllResources(root.$store);
		const { isLoaded: areGroupsLoaded, isLoading: areGroupsLoading, hasError: hasGroupsError } = useGroups(root.$store);
		const isLoading = computed(() => areGroupsLoading.value || areResourcesLoading.value);
		const isLoaded = computed(() => areGroupsLoaded.value && areResourcesLoaded.value);
		const hasError = computed(() => hasGroupsError.value || hasResourcesError.value);
		const fieldRows = computed<FieldRow[]>(() => root.$store.getters['fieldsView/getFieldRows']);
		const activeFieldRowVisible = computed<boolean>(() => root.$store.getters['fieldsView/getActiveFieldRowVisible']);
		const hasAccessToFields = computed(() => isLoaded.value && fields.value.length > 0);

		const numberToRender = ref(FIELDS_LIST_DEFAULT_NUMBER_TO_RENDER);
		const fieldsRowsToRender = computed(() => fieldRows.value.slice(0, numberToRender.value));
		const handleViewMore = () => {
			numberToRender.value = Math.min(
				fieldRows.value.length,
				numberToRender.value + FIELDS_LIST_ADDITIONAL_AMOUNT_TO_SHOW_ON_VIEW_MORE
			);
		};
		watch(fieldRows, () => {
			numberToRender.value = FIELDS_LIST_DEFAULT_NUMBER_TO_RENDER;
		});

		const clearAllFilters = () => root.$store.dispatch('fieldsView/clearAllFilters');

		watchEffect(() => {
			if (!activeFieldRowVisible.value) {
				root.$store.dispatch('fieldsView/clearActiveFieldId');
			}
		});

		return {
			isLoaded,
			isLoading,
			hasError,
			hasAccessToFields,
			fieldRows,
			clearAllFilters,
			fieldsRowsToRender,
			handleViewMore,
		};
	},
});
